import { combineReducers } from 'redux'

import authReducer from './auth/reducer'
import changeState from './layout/reducer'
import loadingReducer, { onlineReducer } from './loading/reducer'
import dataWebsiteReducer from './dataWebsite/reducer'
import cartReducer from './cart/reducer'

/**
 * Root reducer
 * @type {Reducer<any> | Reducer<any, AnyAction>}
 */
const rootReducers = combineReducers({
  authReducer: authReducer,
  sidebarShow: changeState,
  loadingReducer: loadingReducer,
  onlineReducer: onlineReducer,
  dataWebsiteReducer: dataWebsiteReducer,
  cartReducer: cartReducer,
})

export default rootReducers
